export default {
  "/api/payment/submit": {
    success: true,
  }
};
